<template>
    <div class="table-responsive">
        <table class="table table-grid table-hover table-selectable">
            <thead>
                <tr>
                    <th>Dashboard</th>
                    <th>Default user access</th>
                    <th>Default date range</th>
                    <th>Default historical trend</th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-clickable
                    v-for="item in dashboards"
                    :key="item.dashboardID"
                    :class="{ active: activeDashboardID == item.dashboardID }"
                    @click="editDashboard(item.dashboardID)"
                >
                    <td>
                        <span class="text-link">{{item.dashboardName}}</span>
                    </td>
                    <td>
                        {{getPermissionTypeText(item.defaultDashboardPermission)}}
                    </td>
                    <td>
                        {{getDateRangeTypeText(item.defaultDateRange)}}, grouped by {{getGroupByTypeText(item.defaultGroupBy)}}
                    </td>
                    <td>
                        {{getTrendOffsetTypeText(item.defaultTrendOffset)}}
                    </td>
                </tr>
                <tr v-if="dashboards && !dashboards.length">
                    <td colspan="99" class="cell-empty">No dashboards found</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>


<script>
    import _ from 'lodash';
    import { AsyncMixin } from 'pdk/mixins';
    import { getDateRanges } from 'pdk/components/date-range-picker';
    import { groups } from '@/services';
    import { dashboards } from 'dashboard-pdk/services';


	export default {
		name: 'group-dashboards-grid',
        mixins: [AsyncMixin],
        props: {
            locationGroupId: {
                type: String,
                required: true
            }
        },
		data() {
            return {
                activeDashboardID: null,
                dashboards: undefined,
                permissionTypes: undefined,
                dateRangeTypes: undefined,
                groupByTypes: undefined,
                trendOffsetTypes: undefined
			};
        },
        computed: {
            ready() {
                if (!this.dashboards) return false;
                if (!this.permissionTypes) return false;
                if (!this.dateRangeTypes) return false;
                if (!this.groupByTypes) return false;

                return true;
            }
        },
        created() {
            this.getPermissionTypes();
            this.getTrendOffsetTypes();
            this.getDashboards();
            this.getDateRanges();
            this.getGroupByTypes();
        },
        methods: {
            getDateRanges() {
                this.dateRangeTypes = _.filter(getDateRanges(), (t) => t.relative);
            },
            getGroupByTypes() {
                return this.async(dashboards.getDateRangeGroupByTypes())
                    .then((types) => {
                        this.groupByTypes = types;
                    });
            },
            getTrendOffsetTypes() {
                return this.async(dashboards.getTrendOffsetTypes())
                    .then((types) => {
                        this.trendOffsetTypes = types;
                    });
            },
            getDashboards() {
                this.async(groups.getDashboards({
                    locationGroupID: this.locationGroupId
                })).then((dashboardList) => {
                    this.dashboards = dashboardList;
                });
            },
            getPermissionTypes() {
                this.async(dashboards.getDashboardPermissionTypes())
                    .then((types) => {
                        this.permissionTypes = types;
                    });
            },

            getDateRangeTypeText(id) {
                if (!this.dateRangeTypes || !this.dateRangeTypes.length) return id;

                const type = _.find(this.dateRangeTypes, (t) => t.id == id);
                if (!type) return id;

                return type.name;
            },
            getGroupByTypeText(id) {
                if (!this.groupByTypes || !this.groupByTypes.length) return id;

                const type = _.find(this.groupByTypes, (t) => t.groupByTypeID == id);
                if (!type) return id;

                return type.groupByTypeText.toLowerCase();
            },
            getTrendOffsetTypeText(id) {
                if (!this.trendOffsetTypes || !this.trendOffsetTypes.length) return id;

                const type = _.find(this.trendOffsetTypes, (t) => t.trendOffsetTypeID == id);
                if (!type) return id;

                return type.trendOffsetTypeText;
            },
            getPermissionTypeText(id) {
                if (!this.permissionTypes || !this.permissionTypes.length) return id;

                const type = _.find(this.permissionTypes, (t) => t.dashboardPermissionTypeID == id);
                if (!type) return id;

                return type.dashboardPermissionTypeText;
            },

            editDashboard(dashboardID) {
                this.activeDashboardID = dashboardID;
                this.$router.push({ name: 'manage-group-dashboard', params: { locationGroupId: this.locationGroupId, dashboardId: dashboardID } });
            }
		}
	};
</script>
